import {
  FaFileAlt,
  FaUsers,
  FaUniversity,
  FaStar
} from "react-icons/fa";

import "../styles/statsSection.css";

function StatsSection() {
  return (
    <section className="stats-section">

      <div className="section-header">

        <h2>CompExams by the Numbers</h2>

        <p>
          Helping students prepare for success.
        </p>

      </div>

      <div className="stats-grid">

        <div className="stat-card">
          <FaFileAlt className="stat-icon" />
          <h3>1,500+</h3>
          <p>Exam Papers</p>
        </div>

        <div className="stat-card">
          <FaUsers className="stat-icon" />
          <h3>5,000+</h3>
          <p>Students Served</p>
        </div>

        <div className="stat-card">
          <FaUniversity className="stat-icon" />
          <h3>100+</h3>
          <p>Institutions</p>
        </div>

        <div className="stat-card">
          <FaStar className="stat-icon" />
          <h3>Trusted</h3>
          <p>Learning Platform</p>
        </div>

      </div>

    </section>
  );
}

export default StatsSection;